import { useSession } from 'queries/session';

export const useIsPrimaryStudent = () => {
  const { data } = useSession();
  return !!data?.student?.isPrimaryStudent;
};
